import React, { useEffect, useMemo, useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM, TRANSITION } from "../Theme/styles";
import TaskModal from "../Components/TaskModal";
import { EVENTS, eventInfo } from "../events";

const MAIN_EVENTS = ["task_created", "task_deleted", "status_changed", "deadline_passed"];

const Activity = () => {
  const [entries, setWpisy] = useState([]);
  const [people, setOsoby] = useState([]);
  const [filter, setFiltr] = useState(null);
  const [loading, setLaduje] = useState(true);
  const [openTask, setOtwarte] = useState(null);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${getToken()}` };
    axios
      .get(`${API_URL}/log`, { withCredentials: true, headers: headers })
      .then((r) => setWpisy(r.data || []))
      .catch((e) => console.error("Nie udało się pobrać loga", e))
      .finally(() => setLaduje(false));
    axios
      .get(`${API_URL}/users`, { withCredentials: true, headers: headers })
      .then((r) => setOsoby(r.data || []))
      .catch(() => setOsoby([]));
  }, []);

  const visible = useMemo(
    () => (filter ? entries.filter((w) => w.event === filter) : entries),
    [entries, filter]
  );

  const policz = (key) => entries.filter((w) => w.event === key).length;

  return (
    <Flex direction={"column"} h={"100%"} minH={0} gap={4} w={"100%"}>
      <Flex direction={"column"} gap={0.5}>
        <Text
          fontSize={"11px"}
          fontWeight={"500"}
          letterSpacing={"0.08em"}
          textTransform={"uppercase"}
          color={FORUM.tekstPrzygaszony}
        >
          Co się działo
        </Text>
        <Text fontSize={"xl"} fontWeight={"600"} lineHeight={"1.1"} color={FORUM.tekstJasny}>
          Dziennik
        </Text>
      </Flex>

      <Flex gap={2} wrap={"wrap"} flexShrink={0}>
        <Chip name={"Wszystko"} ile={entries.length} selected={!filter} onClick={() => setFiltr(null)} />
        {MAIN_EVENTS.map((key) => (
          <Chip
            key={key}
            name={EVENTS[key].name}
            ile={policz(key)}
            kolor={EVENTS[key].kolor}
            selected={filter === key}
            onClick={() => setFiltr(filter === key ? null : key)}
          />
        ))}
      </Flex>

      <Box flex={1} minH={0} overflowY={"auto"}>
        {loading && (
          <Text fontSize={"sm"} color={FORUM.tekstPrzygaszony}>
            Wczytuję…
          </Text>
        )}
        {!loading && visible.length === 0 && (
          <Text fontSize={"sm"} color={FORUM.tekstPrzygaszony}>
            Nic tu jeszcze nie ma.
          </Text>
        )}

        <Flex direction={"column"} gap={1}>
          {visible.map((w) => {
            const zdarzenie = eventInfo(w.event);
            const usuniete = w.event === "task_deleted";
            return (
              <Flex
                key={w.id}
                align={"center"}
                gap={3}
                px={3}
                py={2}
                bg={FORUM.panel}
                border={"1px solid"}
                borderColor={FORUM.obramowanie}
                borderRadius={"md"}
                transition={TRANSITION}
                cursor={usuniete ? "default" : "pointer"}
                _hover={usuniete ? {} : { bg: FORUM.panelJasny }}
                onClick={() => !usuniete && setOtwarte(w.task_id)}
              >
                <Text
                  fontSize={"11px"}
                  color={FORUM.tekstPrzygaszony}
                  minW={"88px"}
                  whiteSpace={"nowrap"}
                >
                  {new Date(w.created_at).toLocaleString("pl-PL", {
                    day: "2-digit",
                    month: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                  })}
                </Text>

                <Text
                  fontSize={"10px"}
                  fontWeight={"600"}
                  color={zdarzenie.kolor}
                  bg={FORUM.plakietka}
                  borderRadius={"full"}
                  px={2}
                  py={"1px"}
                  minW={"110px"}
                  textAlign={"center"}
                  whiteSpace={"nowrap"}
                >
                  {zdarzenie.name}
                </Text>

                <Box flex={1} minW={0}>
                  <Text fontSize={"sm"} color={FORUM.tekst} noOfLines={1}>
                    {w.task_title || `task #${w.task_id}`}
                  </Text>
                  {w.details && (
                    <Text fontSize={"11px"} color={FORUM.tekstPrzygaszony} noOfLines={1}>
                      {w.details}
                    </Text>
                  )}
                </Box>

                <Text
                  fontSize={"11px"}
                  color={w.actor_id ? "#6C99FF" : FORUM.tekstPrzygaszony}
                  whiteSpace={"nowrap"}
                >
                  {w.actor_name}
                </Text>
              </Flex>
            );
          })}
        </Flex>
      </Box>

      {openTask && (
        <TaskModal
          isOpen={Boolean(openTask)}
          onClose={() => setOtwarte(null)}
          taskId={openTask}
          peoples={people}
        />
      )}
    </Flex>
  );
};

export const Chip = ({ name, ile, kolor, selected, onClick }) => (
  <Flex
    align={"center"}
    gap={2}
    px={3}
    py={1.5}
    borderRadius={"md"}
    cursor={"pointer"}
    border={"1px solid"}
    borderColor={selected ? "#6C99FF" : FORUM.obramowanie}
    bg={selected ? "rgba(108,153,255,0.10)" : FORUM.tlo}
    transition={TRANSITION}
    _hover={{ borderColor: "rgba(255,255,255,0.18)" }}
    onClick={onClick}
  >
    <Text fontSize={"sm"} color={kolor || FORUM.tekst}>
      {name}
    </Text>
    <Text fontSize={"11px"} color={FORUM.tekstPrzygaszony}>
      {ile}
    </Text>
  </Flex>
);

export default Activity;
